import PropTypes from 'prop-types';
import BadgeShape from '@/shapes/Badge';
import CertificationTitle from './CertificationTitle';
import CertificationExcerpt from './CertificationExcerpt';
import CertificationNumbers from './CertificationNumbers';
import CertificationActions from './CertificationActions';
import CertificationNumber from './CertificationNumber';
import BadgeColumn from './BadgeColumn';

const defaultProps = {
  certificacionWithExam: false,
  showExcerpt: false,
  showNumbers: true,
  minimumApprovalLevel: null,
  examCompletionTimeLimit: null,
  numberOfExamQuestions: null,
};

const propTypes = {
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  uri: PropTypes.string.isRequired,
  badge: BadgeShape.isRequired,
  color: PropTypes.string.isRequired,
  certificacionWithExam: PropTypes.bool,
  showExcerpt: PropTypes.bool,
  showNumbers: PropTypes.bool,
  minimumApprovalLevel: PropTypes.number,
  examCompletionTimeLimit: PropTypes.number,
  numberOfExamQuestions: PropTypes.number,
};

export default function CertificationDetails({
  title,
  excerpt,
  uri,
  badge,
  color,
  certificacionWithExam,
  showNumbers,
  minimumApprovalLevel,
  examCompletionTimeLimit,
  numberOfExamQuestions,
  product,
}) {
  const showNumbersFinal = showNumbers && (certificacionWithExam !== null && certificacionWithExam);
  const showExcerptFinal = showNumbersFinal === false && excerpt !== null;
  const showProduct = product !== null;

  return (
    <div className="flex flex-col space-y-4 xl:space-y-0 w-full min-h-full relative overflow-hidden">
      <div className="flex-1 flex flex-col relative">
        <div className="grid grid-cols-12">
          <div className="flex items-center relative z-10 col-span-12">
            <div className="relative z-10 px-5 pb-5 flex flex-col space-y-4 w-full">
              <BadgeColumn title={title} uri={uri} badge={badge} color={color} />
              <div className="flex-1 text-gray-900 text-center">
                <CertificationTitle title={title} url={uri} />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col space-y-4 lg:pb-4 xl:pb-6 lg:col-span-4 px-6">
          <div className="space-y-2">
            {showProduct && (
              <CertificationNumber
                label="Precio"
                value={(
                  <div className="text-xl text-gray-900 leading-none">
                    {product.price}
                  </div>
                )}
              />
            )}
            {showExcerptFinal && (<CertificationExcerpt excerpt={excerpt} />)}
            {showNumbersFinal && (<CertificationNumbers minimumApprovalLevel={minimumApprovalLevel} examCompletionTimeLimit={examCompletionTimeLimit} numberOfExamQuestions={numberOfExamQuestions} />)}
          </div>
        </div>
      </div>
      <div className="bg-gray-100 px-6 py-6 rounded-b-lg w-full overflow-hidden">
        <CertificationActions url={uri} product={product} />
      </div>
    </div>
  );;
}

CertificationDetails.defaultProps = defaultProps;
CertificationDetails.propTypes = propTypes;

